import { z } from "zod";

/**
 * The getting-started checklist, as facts rather than prose.
 *
 * A step is done because the household actually has the thing — an account, a
 * committed statement, a rule, a budget — not because anyone ticked it off. So
 * there is no per-step write path, no state to fall out of step with the data,
 * and someone invited into an established household arrives with every step
 * already satisfied.
 *
 * The wording and the link for each step live on the client, because they are
 * copy and the server has no opinion on either.
 */
export const OnboardingStepId = z.enum(["household", "account", "statement", "rule", "budget"]);

export const OnboardingStep = z.object({
  id: OnboardingStepId,
  done: z.boolean(),
  /** How many of the thing the household has. */
  count: z.number().int().nonnegative(),
  /** The name of one of them, where naming it reads better than counting. */
  label: z.string().nullable(),
});

export const OnboardingProgress = z.object({
  /** Whether this user has put the checklist away. Per user, not per household. */
  dismissed: z.boolean(),
  steps: z.array(OnboardingStep),
});

export type OnboardingStepId = z.infer<typeof OnboardingStepId>;
export type OnboardingStep = z.infer<typeof OnboardingStep>;
export type OnboardingProgress = z.infer<typeof OnboardingProgress>;
